import React, { useState } from "react";
import {
  Timeline,
  Collapse,
  Typography,
  Tooltip,
  Progress,
  Space,
  Spin,
} from "antd";
import {
  FolderOpenOutlined,
  BookOutlined,
  CheckCircleTwoTone,
  PlayCircleTwoTone,
  ClockCircleTwoTone,
  LockOutlined,
} from "@ant-design/icons";
import useCommonListing from "../../AdminComponents/customHooks/useCommonListing";

const { Panel } = Collapse;
const { Text } = Typography;

const statusIcons = {
  Completed: (
    <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: 18 }} />
  ),
  Started: (
    <PlayCircleTwoTone twoToneColor="#1677ff" style={{ fontSize: 18 }} />
  ),
  Enrolled: (
    <ClockCircleTwoTone
      twoToneColor="#faad14"
      style={{ fontSize: 18, background: "transparent" }}
    />
  ),
  Locked: <LockOutlined style={{ color: "#aaa", fontSize: 18 }} />,
};

export const LearningPathJourney = ({ record, id }) => {
  const [loadAgain, setLoadAgain] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const LoadAPI = () => {
    setLoadAgain((prev) => !prev);
  };
  const {
    data,
    // itemsLength,
    loading,
    // filterData,
    // onShowSizeChange,
    // onPageChange,
    // handleSearchChange,
  } = useCommonListing({
    passSize: 10,
    passPage: 1,
    passURL: `learn/learningpathusercourselist/${id}/${record?.id}/`,
    takeFromData: (res) => res?.data,
    loadAgain: loadAgain,
    noPaginationAndFilters: true,
  });
  console.log(data);

  // eslint-disable-next-line no-unused-vars
  const pathData = [
    {
      course_id: 24065,
      course_name: "Track Trest",
      course_code: "1201334",
      status: "Enrolled",
      mode: "Virtual",
      course_type: "Course",
      child_courses: [],
    },
    {
      course_id: 24064,
      course_name: "Sep 25 Test",
      course_code: "BUD001",
      status: "Enrolled",
      mode: null,
      course_type: "Bundle",
      child_courses: [
        {
          course_id: 24067,
          course_name: "Nexa Learn Test 2",
          course_code: "nexa002",
          course_type: "Course",
          mode: "E-Learning",
          status: "Completed",
        },
        {
          course_id: 24077,
          course_name: "Virtual Course Test",
          course_code: "213123",
          course_type: "Course",
          mode: "Virtual",
          status: "Enrolled",
        },
        {
          course_id: 24078,
          course_name: "E-Learning Course",
          course_code: "course",
          course_type: "Course",
          mode: "E-Learning",
          status: "Enrolled",
        },
      ],
    },
    {
      course_id: 24079,
      course_name: "Oct 9",
      course_code: "bbid",
      status: "Enrolled",
      mode: null,
      course_type: "Bundle",
      child_courses: [
        {
          course_id: 24077,
          course_name: "Virtual Course Test",
          course_code: "213123",
          course_type: "Course",
          mode: "Virtual",
          status: "Enrolled",
        },
        {
          course_id: 24078,
          course_name: "E-Learning Course",
          course_code: "course",
          course_type: "Course",
          mode: "E-Learning",
          status: "Enrolled",
        },
      ],
    },
  ];

  console.log(data);

  const getBundleProgress = (courses = []) => {
    if (!courses.length) return 0;
    const completed = courses.filter((c) => c.status === "Completed").length;
    return Math.round((completed / courses.length) * 100);
  };
  return (
    <Spin spinning={loading}>
      <div
        style={{
          maxWidth: 750,
          maxHeight: "40vh",
          overflowY: "auto",
          margin: "0 auto",
          padding: "24px 16px",
          fontFamily: "Roboto, sans-serif",
        }}
      >
        <Timeline
          mode="left"
          style={{
            "--line-color": "#e0e0e0",
          }}
        >
          {data.map((item, index) => {
            const isActive =
              item.status === "Started" || item.status === "Enrolled";
            const lineColor =
              item.status === "Completed"
                ? "green"
                : isActive
                ? "#1677ff"
                : "#ccc";

            return (
              <Timeline.Item
                key={item.course_id}
                color={lineColor}
                dot={
                  item.course_type?.toLowerCase() === "bundle" ? (
                    <FolderOpenOutlined
                      style={{
                        fontSize: 20,
                        color: isActive ? "#1677ff" : lineColor,
                      }}
                    />
                  ) : (
                    <BookOutlined
                      style={{
                        fontSize: 18,
                        color: isActive ? "#1677ff" : lineColor,
                      }}
                    />
                  )
                }
              >
                <div
                  style={{
                    background: isActive ? "#f0f7ff" : "#fff",
                    border: isActive
                      ? "1px solid #1677ff"
                      : "1px solid rgba(0,0,0,0.1)",
                    borderRadius: 12,
                    padding: "16px 18px",
                    transition: "0.3s",
                    boxShadow: isActive
                      ? "0 3px 10px rgba(22,119,255,0.2)"
                      : "0 2px 6px rgba(0,0,0,0.05)",
                  }}
                >
                  {/* Header */}
                  <Space align="center" size="middle">
                    {statusIcons[item.status] || null}
                    <Text strong style={{ fontSize: 15 }}>
                      {index + 1}. {item.course_name}
                    </Text>
                  </Space>

                  {/* Optional: Mode or Code */}
                  {item.course_code && (
                    <Text
                      type="secondary"
                      style={{ display: "block", fontSize: 13, marginTop: 4 }}
                    >
                      Code: {item.course_code}
                      {item.mode ? ` | Mode: ${item.mode}` : ""}
                    </Text>
                  )}

                  {/* Bundle Courses */}
                  {item.course_type?.toLowerCase() === "bundle" &&
                    Array.isArray(item.child_courses) &&
                    item.child_courses.length > 0 && (
                      <Collapse
                        ghost
                        style={{ marginTop: 12, cursor: "pointer" }}
                        expandIconPosition="end"
                      >
                        <Panel
                          header={
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                              }}
                            >
                              <Progress
                                percent={getBundleProgress(item.child_courses)}
                                size="small"
                                style={{ width: 140, marginRight: 10 }}
                              />
                              <Text type="secondary" style={{ fontSize: 13 }}>
                                Complete
                              </Text>
                            </div>
                          }
                          key={item.course_id}
                        >
                          <Timeline
                            style={{
                              marginLeft: 20,
                              marginTop: 10,
                              marginBottom: 0,
                              padding: 0,
                            }}
                            items={item.child_courses.map((course) => ({
                              color:
                                course.status === "Completed"
                                  ? "green"
                                  : course.status === "Started" ||
                                    course.status === "Enrolled"
                                  ? "blue"
                                  : "gray",
                              dot: (
                                <Tooltip title={course.status}>
                                  {statusIcons[course.status]}
                                </Tooltip>
                              ),
                              children: (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    padding: "4px 0",
                                  }}
                                >
                                  <Text strong style={{ color: "#555" }}>
                                    {course.course_name}
                                  </Text>
                                  <Text
                                    type="secondary"
                                    style={{ fontSize: 12 }}
                                  >
                                    ({course.mode || "N/A"})
                                  </Text>
                                </div>
                              ),
                            }))}
                          />
                        </Panel>
                      </Collapse>
                    )}
                </div>
              </Timeline.Item>
            );
          })}
        </Timeline>
      </div>
    </Spin>
  );
};
